import { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, InputGroup, Modal, Badge, OverlayTrigger, Tooltip} from "react-bootstrap";
import { FaPlus, FaRegEdit,FaEdit, FaTrash, FaSearch, FaEye, FaFile, FaCheck, FaTimes, FaDownload, FaExclamationTriangle, FaRegCalendarAlt, FaThLarge, FaList, FaBars, FaFilter, FaEraser } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import api from "../../services/api";
import { hasPerm,
         formataDataHoraExibicao,
         getCurrentUser,
         situacoesAgendamento,
         formataDataExibicao,
         tiposArquivos,
         isLaudoBloqueadoParaUsuarioAtual,
         isEdicaoAgendamentoBloqueada,
         prestadorPodeEditarProprioAgendamento,
         agendamentoEncerrado,
         formatarValorAPI,
         formatarValorLocal }
         from '../../common/utils';
import Paginacao from '../../common/pagination';
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { getConfig } from '../../common/config';
import AcoesLinkPaciente from '../Meetings/AcoesLinkPaciente';
import ConfirmarRealizacaoModal from '../Modals/ConfirmarRealizacaoModal';
import {
    permiteAtendimentoFrustrado, montarHtmlAtendimentoFrustrado, configurarEventosAtendimentoFrustrado,
    lerAtendimentoFrustrado, camposDinamicosAtivos, MSG_OBSERVACAO_FRUSTRADO_OBRIGATORIA
} from '../../common/atendimentoFrustrado';
import ModalPersonalizadoServicos from '../Modals/ModalPersonalizadoServicos';
import CardsAgendamentos from './CardsAgendamentos';
import LinhasDensasAgendamentos from './LinhasDensasAgendamentos';
import { usaLayoutNovoListas } from '../../common/config';
import { debounce } from 'lodash';

//Preferencias por usuario: quem escolheu cards ou uma ordem nao quer reescolher a cada acesso.
const CHAVE_VISAO = 'agendamentos_visao';
const CHAVE_ORDENACAO = 'agendamentos_ordenacao';

const ORDENACOES = [
    { valor: '-id', rotulo: 'Cadastro (mais recente)' },
    { valor: '-data_agendamento', rotulo: 'Data do agendamento (mais recente)' },
    { valor: 'data_agendamento', rotulo: 'Data do agendamento (mais antiga)' },
];

class Agendamentos extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            beneficiario_id: "",
            page_numb: 1,
            dados_usuario: '',
            configProgramaAtual: null,
            //todos abrem na lista: é a visão mais próxima da tabela anterior, então quem já
            //usava a tela reconhece o que vê. Cards ficam a um clique e a escolha é lembrada
            //por usuário — inclusive para o prestador, que tende a preferir cards mas não
            //deve encontrá-los sem ter pedido.
            visao: localStorage.getItem(CHAVE_VISAO) === 'cards' ? 'cards'
                : (localStorage.getItem(CHAVE_VISAO) || 'lista'),
            ordenacao: localStorage.getItem(CHAVE_ORDENACAO) || '-id',
            loading: true,
            showConfirmarRealizacaoModal: false,
            agendamentoParaConfirmar: null,
            showModalInformarData: false,
            agendamentoInformarData: null,
            informar_data: '',
            informar_valor: '',
            salvandoData: false,
            showModalPersonalizadoServicos: false,
            agendamentoFormularioDinamico: null,
            showModalArquivos: false,
            arquivos: [],
            agendamento_selecionado: null,
            agendamento_selecionado: null,
            loadingArquivos: false,
            // Upload states
            showModalArquivosEdit: false,
            arquivo_id: null,
            arquivo_upload: null,
            arquivo_nome: '',
            arquivo_tipo: '',
            arquivoHelper: '',
            //Filtros da operação (navegadora/gestora). Ficam abertos até o usuário fechar,
            //para ele ir ajustando e vendo o resultado logo abaixo.
            filtros_abertos: false,
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_prestador_id: '',
            filtro_prestador_nome: '',
            filtro_situacao: '',
            filtro_sem_data: false,
        };

        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        
        this.debouncedConsulta = debounce((termoBusca) => {
            this.consultaRegistro(this.state.beneficiario_id, 1, termoBusca);
        }, 600);
    }

    componentDidMount(){
        this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb, "");
        this.carregarConfigProgramaAtual();
        this.carregarPrestadorLogado();
        this.abrirConfirmacaoVindaDaSala();
    }

    // A flag `permite_agendar_servico` vive no cadastro do prestador, nao no user do cookie.
    // Sem esse fetch a psicologa nao consegue editar o proprio agendamento nesta tela.
    carregarPrestadorLogado = async () => {
        const user = getCurrentUser();
        if (user?.tipo_usuario !== 'prestador' || !user?.prestador_id) return;
        try {
            const { data } = await api.get(`/pessoas/prestadores/${user.prestador_id}/`);
            this.setState((prev) => ({
                dados_usuario: {
                    ...(prev.dados_usuario || user),
                    permite_agendar_servico: !!data.permite_agendar_servico,
                    prestador_categoria: data.categoria || prev.dados_usuario?.prestador_categoria,
                },
            }));
        } catch (e) {
            console.error('Erro ao carregar dados do prestador logado:', e);
        }
    }

    /**
     * A sala de vídeo devolve o profissional aqui com `?confirmar=<id>` quando ele encerra
     * o atendimento (ver MeetingsEdit.handleBackToPanel). Buscamos o agendamento pelo id
     * em vez de procurá-lo na lista, porque ele pode estar em outra página do resultado.
     */
    abrirConfirmacaoVindaDaSala = async () => {
        const id = new URLSearchParams(window.location.search).get('confirmar');
        if (!id) return;

        //limpa a URL antes de abrir: um F5 não deve reabrir o modal
        window.history.replaceState({}, '', window.location.pathname);

        try {
            const { data } = await api.get(`/agendamentos/${id}`);
            if (['finalizado', 'cancelado'].includes(data.situacao)) return;

            const MySwal = withReactContent(Swal);
            await MySwal.fire({
                icon: 'info',
                title: 'Atendimento encerrado',
                html: 'A sala foi encerrada. Vamos registrar a realização do serviço agora.',
                confirmButtonText: 'Registrar realização',
            });
            this.handleConfirmarServico(data);
        } catch (e) {
            console.error('Não foi possível abrir a confirmação do agendamento:', e);
        }
    }

    // Carrega a configuracao do programa atual (ambiente) para gatear o botao de
    // adicionar agendamento (agendamento.bloquear_edicao). Cache primeiro, API depois.
    carregarConfigProgramaAtual = async () => {
        const dadosUsuario = getCurrentUser();
        const programaId = dadosUsuario?.ambiente_programa_id;
        if (!programaId) return;

        let configuracoes = null;
        try {
            const cache = localStorage.getItem(`programa_configuracoes_${programaId}`);
            if (cache) configuracoes = JSON.parse(cache);
        } catch (e) {
            configuracoes = null;
        }

        if (configuracoes === null) {
            try {
                const resp = await api.get(`/programas/${programaId}/`);
                configuracoes = resp.data?.configuracoes || {};
            } catch (e) {
                return;
            }
        }

        this.setState({ configProgramaAtual: configuracoes });
    }

    /**
     * A ordenação é da API (`ordering`), porque só ela vê a base inteira — ordenar apenas
     * o que chegou trocaria a ordem dentro da página e mentiria sobre o resto. Este
     * reordenamento local é rede de proteção para ambiente onde o backend com o parâmetro
     * ainda não subiu: ali a página vem por id e pelo menos aparece na ordem pedida.
     */
    ordenaResultado = (dados) => {
        if (!dados || !Array.isArray(dados.results)) return dados;
        if (this.state.ordenacao === '-id') return dados;

        const desc = this.state.ordenacao.startsWith('-');
        const valor = (item) => {
            const d = item.data_agendamento ? new Date(item.data_agendamento).getTime() : 0;
            return Number.isNaN(d) ? 0 : d;
        };

        const results = [...dados.results].sort((a, b) => (desc ? valor(b) - valor(a) : valor(a) - valor(b)));
        return { ...dados, results };
    }

    consultaRegistro(beneficiario_id, page_numb = 1, search = ""){
        const dados_user = getCurrentUser();
        
        const termoBusca = search !== undefined ? search : this.state.busca;

        this.setState({
            dados_usuario: dados_user,
            loading: true,
            page_numb: page_numb
        });

        let url = `/agendamentos/?page=${page_numb}`;

        if (dados_user['tipo_usuario'] && ['prestador', 'operador', 'beneficiario'].includes(dados_user['tipo_usuario'])) {
             url += `&tipo_usuario=${dados_user['tipo_usuario']}`;
        }

        if (beneficiario_id) {
            url += `&beneficiario_id=${beneficiario_id}`;
        }

        if (termoBusca) {
            url += `&search=${encodeURIComponent(termoBusca)}`;
        }

        if (this.state.filtro_data_inicio) url += `&data_inicio=${this.state.filtro_data_inicio}`;
        if (this.state.filtro_data_fim) url += `&data_fim=${this.state.filtro_data_fim}`;
        if (this.state.filtro_prestador_id) url += `&prestador_id=${this.state.filtro_prestador_id}`;
        if (this.state.filtro_situacao) url += `&situacao=${this.state.filtro_situacao}`;
        if (this.state.filtro_sem_data) url += `&sem_data=1`;

        const programa_id = dados_user['ambiente_programa_id'] || '';

        url += `&programa_id=${programa_id}`;
        url += `&ordering=${this.state.ordenacao}`;

        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: this.ordenaResultado(response.data)
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar os agendamentos, tente novamente.';

            if(error.response){
                if(error.response.status === 500) erro_msg = 'Servidor indisponível no momento';
                else if(error.response.status === 403) erro_msg = 'Você não tem permissão para acessar essa área';
                else if(error.response.status === 404) erro_msg = 'Recurso não encontrado (Verifique a URL)';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }


    /**
     * Gera o HTML dos campos dinâmicos baseado na configuração
     * @param {Array} campos - Array de configuração de campos
     * @returns {string} HTML gerado
     */
    gerarHtmlCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos)) return '';

        return campos.map(campo => {
            const obrigatorioMark = campo.obrigatorio ? '<span class="text-danger">*</span>' : '';
            const observacao = campo.observacao ? `<small class="text-muted d-block mt-1">${campo.observacao}</small>` : '';

            switch (campo.tipo) {
                case 'file':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="file" 
                                accept="${campo.extensoes || '.pdf,.jpg,.jpeg,.png'}"
                                class="swal2-file form-control" 
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'radio': {
                    const opcoesHtml = (campo.opcoes || []).map((opcao, idx) => {
                        const descricao = campo.descricoes_opcoes?.[opcao] 
                            ? `<small class="text-muted d-block ms-4">${campo.descricoes_opcoes[opcao]}</small>` 
                            : '';
                        return `
                            <div class="form-check">
                                <input 
                                    class="form-check-input" 
                                    type="radio" 
                                    name="swal-campo-${campo.slug}" 
                                    id="swal-campo-${campo.slug}-${idx}" 
                                    value="${opcao}"
                                    data-slug="${campo.slug}"
                                    data-tipo="${campo.tipo}"
                                />
                                <label class="form-check-label" for="swal-campo-${campo.slug}-${idx}">${opcao}</label>
                                ${descricao}
                            </div>
                        `;
                    }).join('');
                    
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label class="text-start d-block mb-2">${campo.label} ${obrigatorioMark}</label>
                            <div class="text-start" data-obrigatorio="${campo.obrigatorio || false}" data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'>
                                ${opcoesHtml}
                            </div>
                            ${observacao}
                        </div>
                    `;
                }
                
                case 'text':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <input 
                                id="swal-campo-${campo.slug}" 
                                type="text" 
                                class="swal2-input" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            />
                            ${observacao}
                        </div>
                    `;
                
                case 'textarea':
                    return `
                        <div class="mb-3 campo-dinamico" data-slug="${campo.slug}">
                            <label for="swal-campo-${campo.slug}" class="text-start d-block">${campo.label} ${obrigatorioMark}</label>
                            <textarea 
                                id="swal-campo-${campo.slug}" 
                                class="swal2-textarea" 
                                placeholder="${campo.placeholder || ''}"
                                data-slug="${campo.slug}"
                                data-tipo="${campo.tipo}"
                                data-obrigatorio="${campo.obrigatorio || false}"
                                data-obrigatorio-condicional='${JSON.stringify(campo.obrigatorio_condicional || null)}'
                            ></textarea>
                            ${observacao}
                        </div>
                    `;
                
                default:
                    return '';
            }
        }).join('');
    };

    /**
     * Configura event listeners para campos com obrigatoriedade condicional
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    configurarEventosCamposDinamicos = (container, campos) => {
        if (!campos || !Array.isArray(campos)) return;

        campos.forEach(campo => {
            if (campo.tipo === 'radio') {
                const radios = container.querySelectorAll(`input[name="swal-campo-${campo.slug}"]`);
                radios.forEach(radio => {
                    radio.addEventListener('change', () => {
                        this.atualizarObrigatoriedadeCondicional(container, campos);
                    });
                });
            }
        });
    };

    /**
     * Atualiza a obrigatoriedade condicional dos campos baseado nos valores selecionados
     * @param {HTMLElement} container - Container do modal
     * @param {Array} campos - Array de configuração de campos
     */
    atualizarObrigatoriedadeCondicional = (container, campos) => {
        campos.forEach(campo => {
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = container.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                
                const elementoCampo = container.querySelector(`#swal-campo-${campo.slug}`);
                const containerCampo = container.querySelector(`.campo-dinamico[data-slug="${campo.slug}"]`);
                
                if (elementoCampo && containerCampo) {
                    const isObrigatorio = valores.includes(valorAtual);
                    const labelEl = containerCampo.querySelector('label');
                    
                    if (labelEl) {
                        const spanObrig = labelEl.querySelector('.text-danger');
                        if (isObrigatorio && !spanObrig) {
                            labelEl.innerHTML = labelEl.textContent + ' <span class="text-danger">*</span>';
                        } else if (!isObrigatorio && spanObrig) {
                            spanObrig.remove();
                        }
                    }
                    
                    elementoCampo.dataset.obrigatorioAtual = isObrigatorio;
                }
            }
        });
    };

    /**
     * Coleta os valores de todos os campos dinâmicos
     * @param {Array} campos - Array de configuração de campos
     * @returns {Object} Objeto com slugs como chaves e valores preenchidos
     */
    coletarValoresCamposDinamicos = (campos) => {
        const valores = {};
        const arquivos = {};
        
        if (!campos || !Array.isArray(campos)) {
            return { valores, arquivos };
        }

        campos.forEach(campo => {
            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (fileInput?.files?.length > 0) {
                        arquivos[campo.slug] = fileInput.files[0];
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (radioSelecionado) {
                        valores[campo.slug] = radioSelecionado.value;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (inputEl) {
                        valores[campo.slug] = inputEl.value.trim();
                    }
                    break;
                }
            }
        });

        return { valores, arquivos };
    };

    /**
     * Valida os campos dinâmicos obrigatórios
     * @param {Array} campos - Array de configuração de campos
     * @returns {string|null} Mensagem de erro ou null se válido
     */
    validarCamposDinamicos = (campos) => {
        if (!campos || !Array.isArray(campos)) {
            return null;
        }

        for (const campo of campos) {
            let isObrigatorio = campo.obrigatorio === true;
            
            if (campo.obrigatorio_condicional) {
                const { campo: campoRef, valores } = campo.obrigatorio_condicional;
                const radioSelecionado = document.querySelector(`input[name="swal-campo-${campoRef}"]:checked`);
                const valorAtual = radioSelecionado?.value || '';
                isObrigatorio = valores.includes(valorAtual);
            }

            if (!isObrigatorio) continue;

            switch (campo.tipo) {
                case 'file': {
                    const fileInput = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!fileInput?.files?.length) {
                        return `Por favor, selecione um arquivo para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'radio': {
                    const radioSelecionado = document.querySelector(`input[name="swal-campo-${campo.slug}"]:checked`);
                    if (!radioSelecionado) {
                        return `Por favor, selecione uma opção para "${campo.label}"`;
                    }
                    break;
                }
                
                case 'text':
                case 'textarea': {
                    const inputEl = document.getElementById(`swal-campo-${campo.slug}`);
                    if (!inputEl?.value?.trim()) {
                        return `Por favor, preencha o campo "${campo.label}"`;
                    }
                    break;
                }
            }
        }

        return null;
    };

    /**
     * O agendamento nasce sem data quando a navegadora registra apenas a necessidade do
     * servico (config agendamento.data_opcional). O front grava 01/01/1900 como "sem data".
     */
    //Sem data o prestador informa; COM data ele altera (a psicologa remarca com o paciente).
    //Antes so liberava sem data, entao a data so podia ser informada uma vez e qualquer
    //remarcacao dependia de acionar a navegadora.
    //Duas portas para o prestador mexer na data, e a do cadastro prevalece:
    //  - `permite_agendar_servico` no cadastro dele: responde pela propria agenda, entao
    //    agenda e altera onde quer que o agendamento apareca, independente do programa;
    //  - `agendamento.data_opcional` do programa: ali o agendamento nasce sem data e
    //    qualquer prestador do programa precisa poder informa-la.
    //Sem uma das duas, so a operacao mexe na data.
    podeInformarData = (item) => {
        if (agendamentoEncerrado(item.situacao)) return false;
        if (prestadorPodeEditarProprioAgendamento(this.state.dados_usuario, item)) return true;
        return getConfig(item?.dados_programa?.configuracoes, 'agendamento.data_opcional', false) === true;
    };

    //Ja tem data => e alteracao, e passa pelo mesmo rito da navegadora (tipo + justificativa).
    ehAlteracaoDeData = (item) => {
        return !!item?.data_agendamento && !String(item.data_agendamento).startsWith('1900-01-01');
    };

    //As duas visões (tabela e cards) precisam decidir isso igual, então a regra sai do JSX.
    //O prestador NAO edita agendamento por esta tela: o caminho dele e "Informar/Alterar
    //data" no proprio card, que passa pelo rito de reagendamento. /agendamentos/edit e
    //tela de operacao.
    podeEditarAgendamento = (item) => {
        if (isEdicaoAgendamentoBloqueada(item.dados_programa?.configuracoes)) return false;
        const perfil = this.state.dados_usuario['tipo_usuario'];
        return perfil !== 'prestador' && perfil !== 'beneficiario';
    };

    podeAnalisarArquivos = (item) => {
        const configValidacao = getConfig(
            item.dados_programa?.configuracoes || item?.dados_atendimento?.programa?.configuracoes,
            'agendamento.validacao_arquivos',
            false
        );
        const user = getCurrentUser();
        return ['operador', 'gestor', ''].includes(user.tipo_usuario)
            || (user.tipo_usuario === 'prestador' && configValidacao && user.prestador_categoria !== 'medicos');
    };

    trocarVisao = (visao) => {
        localStorage.setItem(CHAVE_VISAO, visao);
        this.setState({ visao });
    };

    trocarOrdenacao = (ordenacao) => {
        localStorage.setItem(CHAVE_ORDENACAO, ordenacao);
        //volta para a primeira página: a página 3 de outra ordem não quer dizer nada
        this.setState({ ordenacao, page_numb: 1 }, () => {
            this.consultaRegistro(this.state.beneficiario_id, 1, this.state.busca);
        });
    };

    abrirModalData = (item) => {
        this.setState({
            showModalInformarData: true,
            agendamentoInformarData: item,
            informar_data: '',
            informar_valor: item.valor && Number(item.valor) > 0 ? String(item.valor) : '',
        });
    };

    //Espelha o processarReagendamento do AtendimentosEdit: mesma pergunta, mesma
    //justificativa obrigatoria e mesmo endpoint, para o historico do prestador ficar
    //igual ao da navegadora. Devolve true quando o salvamento pode seguir.
    processarReagendamentoPrestador = async (agendamento, novaData) => {
        const MySwal = withReactContent(Swal);

        const atendimentoId = agendamento?.atendimento_id;
        const servicoProcedimentoId = agendamento?.servico_procedimento_id;

        if (!atendimentoId || !servicoProcedimentoId) {
            await MySwal.fire('Atenção', 'Não foi possível registrar reagendamento: faltam informações do agendamento (serviço/atendimento).', 'error');
            return false;
        }

        const tipoAlteracao = await MySwal.fire({
            title: 'Tipo de alteração',
            text: 'Essa alteração de data é uma correção ou um reagendamento?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Reagendamento',
            cancelButtonText: 'Correção',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#6c757d',
            allowOutsideClick: false,
            reverseButtons: true
        });

        //fechou no X: nao salva
        if (tipoAlteracao.isDismissed && tipoAlteracao.dismiss === Swal.DismissReason.close) return false;

        //correcao: salva sem registrar reagendamento
        if (tipoAlteracao.isDismissed && tipoAlteracao.dismiss === Swal.DismissReason.cancel) return true;

        if (!tipoAlteracao.isConfirmed) return false;

        const result = await MySwal.fire({
            title: 'Justificativa do reagendamento',
            input: 'textarea',
            inputPlaceholder: 'Descreva o motivo do reagendamento...',
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => (!value || !value.trim()) ? 'A justificativa é obrigatória.' : null
        });

        if (!result || !result.value) return false;

        const semFuso = (valor) => valor ? moment(valor).format('YYYY-MM-DDTHH:mm:ss') : null;

        try {
            await api({
                method: 'post',
                url: '/agendamentos/reagendamentos/',
                data: {
                    data_original: semFuso(agendamento.data_agendamento),
                    data_reagendada: semFuso(novaData),
                    atendimento_id: atendimentoId,
                    servico_procedimento_id: servicoProcedimentoId,
                    justificativa: result.value
                }
            });
            return true;
        } catch (err) {
            const msg = err?.response?.data ? JSON.stringify(err.response.data) : 'Erro ao registrar reagendamento. Tente novamente.';
            await MySwal.fire('Atenção', `Erro ao registrar reagendamento: ${msg}`, 'error');
            return false;
        }
    };

    salvarDataAgendamento = async () => {
        const { agendamentoInformarData, informar_data, informar_valor } = this.state;
        const MySwal = withReactContent(Swal);

        if (!informar_data) {
            MySwal.fire('Atenção', 'Informe a data do agendamento.', 'warning');
            return;
        }

        //Alterar data ja informada segue o mesmo rito da navegadora: pergunta se e correcao
        //ou reagendamento e, no reagendamento, exige justificativa e registra o historico.
        //Correcao/cancelamento devolvem false e nada e salvo.
        if (this.ehAlteracaoDeData(agendamentoInformarData)) {
            const seguir = await this.processarReagendamentoPrestador(agendamentoInformarData, informar_data);
            if (!seguir) return;
        }

        this.setState({ salvandoData: true });
        try {
            const payload = { data_agendamento: moment(informar_data).format('YYYY-MM-DD HH:mm:ss') };

            //so envia valor quando o servico permite altera-lo, para nao sobrescrever o que
            //vem da tabela de precos do prestador
            if (agendamentoInformarData?.dados_servico_procedimento?.permite_alterar_valor_agendamento && informar_valor !== '') {
                payload.valor = formatarValorAPI(informar_valor);
            }

            await api.put(`/agendamentos/${agendamentoInformarData.id}/`, payload);

            this.setState({ showModalInformarData: false, agendamentoInformarData: null, salvandoData: false });
            MySwal.fire({
                title: 'Data registrada',
                text: 'A navegadora foi avisada da atualização por e-mail.',
                icon: 'success',
                timer: 2500,
                showConfirmButton: false,
            });
            this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
        } catch (err) {
            this.setState({ salvandoData: false });
            const msg = err.response?.data?.detail || 'Não foi possível registrar a data.';
            MySwal.fire('Erro', msg, 'error');
        }
    };

    handleConfirmarServico = (agendamento) => {
        // Check if new modal should be used
        const useNewModal = getConfig(
            agendamento?.dados_programa?.configuracoes, 
            'show_modal_confirm_service', 
            false
        );
        
        if (useNewModal) {
            this.setState({
                showConfirmarRealizacaoModal: true,
                agendamentoParaConfirmar: agendamento,
            });
            return;
        }
        
        const MySwal = withReactContent(Swal);
        const dataRealizacaoPadrao = moment().tz('America/Sao_Paulo').format('YYYY-MM-DDTHH:mm');
        
        const configuracoesServico = agendamento?.dados_servico_procedimento?.configuracoes;
        const camposDinamicos = configuracoesServico?.modal_confirmacao?.campos || [];
        const temCamposDinamicos = camposDinamicos.length > 0;
        
        const htmlCamposDinamicos = temCamposDinamicos
            ? `<div class="campos-dinamicos-container mt-3 pt-3 border-top">${this.gerarHtmlCamposDinamicos(camposDinamicos)}</div>`
            : '';

        // Atendimento frustrado: o serviço foi executado mas o atendimento não aconteceu.
        const permiteFrustrado = permiteAtendimentoFrustrado(agendamento);
        const htmlFrustrado = montarHtmlAtendimentoFrustrado(agendamento);

        MySwal.fire({
            title: 'Confirmar Realização',
            icon: 'warning',
            html: `
                <div class="text-start container-confirma-servico" style="max-height: 65vh; overflow-y: auto; overflow-x: hidden; padding-right: 10px;">
                <p class="text-start">Deseja confirmar a realização de <strong>${agendamento.dados_servico_procedimento.nome}</strong>?</p>

                <label for="swal-input-data" class="text-start">Data de Realização do Serviço</label>
                <input id="swal-input-data" type="datetime-local"
                    value="${dataRealizacaoPadrao}"
                    min="${moment().subtract(30, 'days').format('YYYY-MM-DDTHH:mm')}"
                    max="${moment().format('YYYY-MM-DDTHH:mm')}"
                    class="swal2-input swal-input-data" />

                ${htmlFrustrado}

                <label for="swal-textarea-anotacoes" class="text-start mt-3">Anotações do Serviço (opcional)</label>
                <textarea id="swal-textarea-anotacoes" class="swal2-textarea swal-textarea-anotacoes"></textarea>

                ${htmlCamposDinamicos}
                </div>
            `,
            width: temCamposDinamicos ? '800px' : '650px',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, confirmar!',
            cancelButtonText: 'Cancelar',
            didOpen: (el) => {
                if (temCamposDinamicos) {
                    this.configurarEventosCamposDinamicos(el, camposDinamicos);
                }

                configurarEventosAtendimentoFrustrado(agendamento, null, camposDinamicos);
            },
            preConfirm: () => {
                const data = document.getElementById('swal-input-data').value;
                const anotacoes = document.getElementById('swal-textarea-anotacoes').value;

                if (!data) {
                    Swal.showValidationMessage('Por favor, selecione uma data de realização');
                    return false;
                }

                const dadosFrustrado = lerAtendimentoFrustrado(agendamento);

                if (dadosFrustrado === null) {
                    Swal.showValidationMessage(MSG_OBSERVACAO_FRUSTRADO_OBRIGATORIA);
                    return false;
                }

                //no frustrado os campos de arquivo saem de cena: não há evidência a anexar
                const camposAtivos = camposDinamicosAtivos(camposDinamicos, dadosFrustrado.frustrado);

                if (temCamposDinamicos) {
                    const erroValidacao = this.validarCamposDinamicos(camposAtivos);
                    if (erroValidacao) {
                        Swal.showValidationMessage(erroValidacao);
                        return false;
                    }
                }

                const dadosDinamicos = temCamposDinamicos
                    ? this.coletarValoresCamposDinamicos(camposAtivos)
                    : { valores: {}, arquivos: {} };

                return {
                    data,
                    anotacoes,
                    atendimentoFrustrado: dadosFrustrado.frustrado,
                    observacaoFrustrado: dadosFrustrado.observacao,
                    dadosConfirmacao: dadosDinamicos.valores,
                    arquivosConfirmacao: dadosDinamicos.arquivos
                };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const dataRealizacao = moment(result.value.data).tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss');
                const anotacoes = result.value.anotacoes;
                const dadosConfirmacao = result.value.dadosConfirmacao;
                const arquivosConfirmacao = result.value.arquivosConfirmacao;

                const payload = {
                    data_realizacao: dataRealizacao,
                    adicionar_servico_atendimento: true,
                    situacao: 'finalizado'
                } 

                
                if (anotacoes && anotacoes.trim() !== '') {
                    payload.anotacoes = anotacoes;
                }

                if (permiteFrustrado) {
                    payload.atendimento_frustrado = result.value.atendimentoFrustrado;

                    if (result.value.atendimentoFrustrado) {
                        payload.observacao_frustrado = result.value.observacaoFrustrado;
                    }
                }

                if (temCamposDinamicos && Object.keys(dadosConfirmacao).length > 0) {
                    const dadosConfirmacaoArray = [];
                    camposDinamicos.forEach(campo => {
                        const valor = dadosConfirmacao[campo.slug];
                        if (valor !== undefined && valor !== null && valor !== "") {
                            dadosConfirmacaoArray.push({
                                slug: campo.slug,
                                label: campo.label,
                                value: valor,
                                type: campo.tipo
                            });
                        }
                    });
                    
                    if (dadosConfirmacaoArray.length > 0) {
                        payload.dados_confirmacao = dadosConfirmacaoArray;
                    }
                }

                const temArquivos = Object.keys(arquivosConfirmacao).length > 0;
                let requestPromise;

                if (temArquivos) {
                    const formData = new FormData();
                    
                    Object.entries(payload).forEach(([key, value]) => {
                        if (value !== null && value !== undefined) {
                            if (typeof value === 'object' && !(value instanceof File)) {
                                formData.append(key, JSON.stringify(value));
                            } else {
                                formData.append(key, value);
                            }
                        }
                    });

                    Object.entries(arquivosConfirmacao).forEach(([slug, arquivo]) => {
                        formData.append(`arquivo_${slug}`, arquivo);
                    });
                    
                    const arquivosKeys = Object.keys(arquivosConfirmacao);
                    if (arquivosKeys.length > 0) {
                        formData.append('arquivo_confirmacao', arquivosConfirmacao[arquivosKeys[0]]);
                    }

                    requestPromise = api.put(`/agendamentos/${agendamento.id}/`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                } else {
                    requestPromise = api.put(`/agendamentos/${agendamento.id}/`, payload);
                }

                requestPromise
                    .then(() => {
                        // Cadastrar relato após confirmar o agendamento
                        if (agendamento.etapa_atual?.id && agendamento.atendimento_id) {
                            const formData = new FormData();

                            formData.append('data', dataRealizacao);
                            formData.append('etapa_id', agendamento.etapa_atual.id);
                            formData.append('atendimento_id', agendamento.atendimento_id);
                            formData.append('tipo', 'etapa');
                            formData.append('titulo', `Realização de ${agendamento.dados_servico_procedimento.nome}`);
                            formData.append('servico_procedimento_id', agendamento.servico_procedimento_id);
                            formData.append('ignorar_cadastro_servico', true);

                            return api.post('/atendimentos/relatos/', formData);
                        }
                        
                        return Promise.resolve(); // Continua a chain mesmo sem cadastrar relato
                    })
                    .then(() => {
                        MySwal.fire({
                            title: 'Sucesso!',
                            text: 'Realização de serviço confirmado com sucesso.',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        }).then((result) => {
                            window.location.reload(); 
                        });
                    })
                    .catch((error) => {
                        const errorMessage =
                            error.response && error.response.data
                                ? error.response.data.message || 'Erro ao confirmar o serviço ou registrar o relato.'
                                : 'Erro ao confirmar o serviço ou registrar o relato.';
                        MySwal.fire({
                            title: 'Erro!',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                        });
                    });
    
            }
        });
    };

    /**
     * Abre o modal de formulário dinâmico para serviços
     */
    handleEnviaCadastroFormularioDinamico = (agendamento) => {
        this.setState({
            showModalPersonalizadoServicos: true,
            agendamentoFormularioDinamico: agendamento,
        });
    };

    /**
     * Verifica se deve mostrar o botão de formulário dinâmico para o agendamento
     */
    deveMostrarBotaoFormularioDinamico = (agendamento) => {
        const configFormulario = agendamento?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        if (!configFormulario) return false;
        
        const showOnEtapa = configFormulario.show_on_etapa;
        const etapaAtualNome = agendamento?.etapa_atual?.nome;
        
        // Se não tem restrição de etapa, mostra sempre
        if (!showOnEtapa || !Array.isArray(showOnEtapa)) return true;
        
        // Verifica se a etapa atual está na lista de etapas permitidas
        return showOnEtapa.includes(etapaAtualNome);
    };

    /**
     * Retorna o título do botão de formulário dinâmico
     */
    getTituloBotaoFormularioDinamico = (agendamento) => {
        const configFormulario = agendamento?.dados_servico_procedimento?.configuracoes?.formulario_dinamico_servicos_procedimentos;
        return configFormulario?.titulo_botao || 'Formulário';
    };

    handleShowModalArquivos = (agendamento) => {
        this.carregaArquivosAgendamento(agendamento.id);
        this.setState({ showModalArquivos: true, agendamento_selecionado: agendamento });
    };

    handleCloseModalArquivos = () => {
        this.setState({ showModalArquivos: false, arquivos: [], agendamento_selecionado: null });
    };

    carregaArquivosAgendamento = (agendamento_id) => {
        this.setState({ loadingArquivos: true });
        api.get(`/agendamentos/arquivos/?agendamento_id=${agendamento_id}`)
            .then(response => {
                const arquivosCarregados = response.data.results.map(dados => ({
                    id: dados.id,
                    nome: dados.nome,
                    arquivo: dados.arquivo,
                    agendamento_id: dados.agendamento_id,
                    data: dados.data,
                    aprovado: dados.aprovado,
                    tipo: dados.tipo,
                    motivo_recusa: dados.motivo_recusa,
                    cadastrado_por_id: dados.cadastrado_por_id
                }));
                this.setState({ arquivos: arquivosCarregados, loadingArquivos: false });
            })
            .catch(error => {
                this.setState({ loadingArquivos: false });
                console.error("Erro ao carregar arquivos:", error);
            });
    };

    handleAprovarArquivo = (arquivo_id) => {
        const MySwal = withReactContent(Swal);
        
        MySwal.fire({
            title: 'Aprovar Arquivo?',
            text: "Confirmar a aprovação deste documento?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3cc172',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, aprovar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loadingArquivos: true });
                api.put(`/agendamentos/arquivos/${arquivo_id}/`, { aprovado: true })
                    .then(() => {
                        this.setState({ loadingArquivos: false });
                        MySwal.fire({
                            title: 'Sucesso', 
                            text: 'Arquivo aprovado.', 
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        if (this.state.agendamento_selecionado) {
                            this.carregaArquivosAgendamento(this.state.agendamento_selecionado.id);
                            this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                        }
                    })
                    .catch(error => {
                        this.setState({ loadingArquivos: false });
                        const msg = error.response?.data?.detail || 'Não foi possível aprovar.';
                        MySwal.fire('Erro', msg, 'error');
                    });
            }
        });
    }

    handleRecusarArquivo = (arquivo_id) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Recusar Arquivo',
            text: "Motivo da não aprovação (será enviado ao laboratório):",
            input: 'textarea',
            inputPlaceholder: 'Ex: Imagem ilegível, paciente incorreto...',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#eb4961',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Recusar e Notificar',
            inputValidator: (value) => {
                if (!value) return 'A justificativa é obrigatória!'
            }
        }).then((result) => {
            if (result.isConfirmed && result.value) {
                this.setState({ loadingArquivos: true });
                api.put(`/agendamentos/arquivos/${arquivo_id}/`, {
                    aprovado: false,
                    motivo_recusa: result.value
                })
                .then(() => {
                    this.setState({ loadingArquivos: false });
                    MySwal.fire({
                        title: 'Recusado', 
                        text: 'Laboratório notificado e status atualizado.', 
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    if (this.state.agendamento_selecionado) {
                        this.carregaArquivosAgendamento(this.state.agendamento_selecionado.id);
                        this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                    }
                })
                .catch(error => {
                    this.setState({ loadingArquivos: false });
                    const msg = error.response?.data?.detail || 'Erro ao processar a recusa.';
                    MySwal.fire('Erro', msg, 'error');
                });
            }
        });
    }


    onChangeBusca(e) {
        const value = e.target.value;
        this.setState({ busca: value });
        this.debouncedConsulta(value);
    }

    //Cada filtro reconsulta sozinho: o painel fica aberto e o usuário vê o resultado mudar
    //abaixo, sem precisar clicar em "Filtrar" a cada ajuste. Sempre volta para a página 1,
    //senão o filtro novo cai numa página que pode nem existir no resultado menor.
    aplicarFiltro = (campos) => {
        this.setState(campos, () => {
            this.consultaRegistro(this.state.beneficiario_id, 1, this.state.busca);
        });
    };

    limparFiltros = () => {
        this.aplicarFiltro({
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_prestador_id: '',
            filtro_prestador_nome: '',
            filtro_situacao: '',
            filtro_sem_data: false,
        });
    };

    carregarPrestadores = async (busca) => {
        if (!busca || busca.length < 2) return [];
        try {
            const resposta = await api.get(`/pessoas/prestadores/?nome=${encodeURIComponent(busca)}&is_active=1`);
            const lista = resposta.data?.results || resposta.data || [];
            return lista.map(p => ({ value: p.id, label: p.nome }));
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    //Quem agenda para os outros precisa dos filtros; prestador e paciente veem só o que é
    //deles, e ali a busca e a ordenação bastam.
    podeUsarFiltrosOperacao = () => {
        const tipo = this.state.dados_usuario['tipo_usuario'];
        return tipo !== 'prestador' && tipo !== 'beneficiario';
    };

    contarFiltrosAtivos = () => {
        return [
            this.state.filtro_data_inicio,
            this.state.filtro_data_fim,
            this.state.filtro_prestador_id,
            this.state.filtro_situacao,
            this.state.filtro_sem_data,
        ].filter(Boolean).length;
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca, num_page);
    }

    handleConfirmarEnvioKit = (atendimento_kit_id, agendamento) => {
        const MySwal = withReactContent(Swal);
        const dataEnvioPadrao = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
    
        MySwal.fire({
            title: 'Confirmar envio do kit',
            icon: 'warning',
            html: `
                <div class="text-start container-confirma-servico">
                <p class="text-start">Deseja confirmar o envio do kit de <strong>${agendamento.dados_servico_procedimento.nome}</strong>?</p>

                <label for="swal-input-data" class="text-start">Data de Envio do kit</label>
                <input id="swal-input-data" type="date"
                    value="${dataEnvioPadrao}"
                    min="${moment().subtract(30, 'days').format('YYYY-MM-DD')}"
                    max="${moment().format('YYYY-MM-DD')}"
                    class="swal2-input swal-input-data" />
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirmar!',
            cancelButtonText: 'Cancelar',
            preConfirm: () => {
                const data = document.getElementById('swal-input-data').value;

                if (!data) {
                    Swal.showValidationMessage('Por favor, selecione uma data de envio');
                    return false;
                }

                return { data };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const dataEnvio = moment(result.value).tz('America/Sao_Paulo').format('YYYY-MM-DD');

                const payload = {
                    data_envio_realizado: dataEnvio,
                    status: 'enviado',
                } 
    
                api
                    .put(`/atendimentos/kits/${atendimento_kit_id}/`, payload)
                    .then(() => {
                        MySwal.fire({
                            title: 'Sucesso!',
                            text: 'Envio de kit confirmado com sucesso.',
                            icon: 'success',
                            confirmButtonColor: '#3085d6',
                        });
                        this.carregarAgendamentos(); 
                    })
                    .catch((error) => {
                        const errorMessage =
                            error.response && error.response.data
                                ? error.response.data.message || 'Erro ao confirmar o envio de kit.'
                                : 'Erro ao confirmar o envio de kit.';
                        MySwal.fire({
                            title: 'Erro!',
                            text: errorMessage,
                            icon: 'error',
                            confirmButtonColor: '#3085d6',
                        });
                    });
            }
        });
    };


    handleChange = (event, fieldName) => {
        this.setState({ [fieldName]: event.target.value });
    };

    onChangeArquivo = (e) => {
        if (e.target.files && e.target.files[0]) {
            this.setState({ arquivo_upload: e.target.files[0] });
            this.setState({ arquivoHelper: '' });
        }
    };

    handleShowModalArquivosEdit = () => {
        // Fecha o modal de listagem para abrir o de edição/upload
        this.setState({ 
            showModalArquivos: false,
            showModalArquivosEdit: true,
            arquivo_id: null,
            arquivo_upload: null,
            arquivo_nome: '',
            arquivo_tipo: '',
            arquivoHelper: ''
        });
    };

    handleCloseModalArquivosEdit = () => {
        // Ao fechar o modal de edição/upload, reabre o de listagem
        this.setState({ 
            showModalArquivosEdit: false,
            showModalArquivos: true 
        });
    };

    saveArquivo = (e) => {
        e.preventDefault();
        const MySwal = withReactContent(Swal);
        const { arquivo_upload, arquivo_nome, arquivo_tipo, agendamento_selecionado } = this.state;

        if (!arquivo_nome) {
            MySwal.fire({ icon: 'warning', title: 'Atenção!', text: 'Informe um nome para o arquivo' });
            return;
        }
        if (!arquivo_tipo) {
            MySwal.fire({ icon: 'warning', title: 'Atenção!', text: 'Selecione um tipo do arquivo' });
            return;
        }
        if (!arquivo_upload) {
            this.setState({ arquivoHelper: 'Selecione um arquivo' });
            return;
        }

        this.setState({ loadingArquivos: true });
        const formData = new FormData();
        formData.append('agendamento_id', agendamento_selecionado.id);
        formData.append('nome', arquivo_nome);
        formData.append('tipo', arquivo_tipo);
        formData.append('arquivo', arquivo_upload);
        
        const usuario = getCurrentUser();
        formData.append('cadastrado_por_id', usuario.id);
        
        // Adiciona a data atual formatada (necessário para o backend)
        const agora = moment().tz("America/Sao_Paulo");
        const dataHoraAtualFormatada = agora.format("YYYY-MM-DD HH:mm:ss");
        formData.append('data', dataHoraAtualFormatada);

        api.post('/agendamentos/arquivos/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(() => {
            this.setState({ loadingArquivos: false, showModalArquivosEdit: false });
            MySwal.fire({ icon: 'success', title: 'Sucesso', text: 'Arquivo enviado com sucesso!' });
            
            // Se o status for 'arquivo_pendente', atualiza para 'finalizado'
            if (agendamento_selecionado.situacao === 'arquivo_pendente') {
                const payloadStatus = { situacao: 'finalizado' };
                api.patch(`/agendamentos/${agendamento_selecionado.id}/`, payloadStatus).then(() => {
                     // Recarrega a lista principal para refletir a mudança de status
                     this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                }).catch(() => {
                     // Mesmo se falhar o patch (ex: já finalizado), tenta recarregar
                     this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
                });
            } else {
                 // Se não era pendente, recarrega igual para garantir
                 this.consultaRegistro(this.state.beneficiario_id, this.state.page_numb);
            }

            // Reabre o modal de listagem e recarrega os arquivos
            this.handleShowModalArquivos(agendamento_selecionado);
        }).catch(error => {
            this.setState({ loadingArquivos: false });
            console.error(error);
            MySwal.fire({ icon: 'error', title: 'Erro', text: 'Erro ao enviar arquivo.' });
        });
    };

    /* ------------------------------------------------------------------
     * LAYOUT ANTERIOR - e o padrao. O layout novo esta em validacao e so vale
     * para quem pedir.
     * O programa entra no layout novo gravando "agendamento": { "layout_listas": true }.
     * Para remover depois: apagar renderRows, renderTabelaAnterior,
     * o import de usaLayoutNovoListas e o ramo do else no render.
     * ------------------------------------------------------------------ */
    renderRows = () => {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {

            const dados_user = getCurrentUser();
            //no medimentor a listagem e de mentorias: mentor e mentorado no lugar de
            //prestador e paciente, e nao existe kit para enviar
            const cachedPogramaTipo = localStorage.getItem(`programa_tipo_${dados_user['ambiente_programa_id']}`);

            if (cachedPogramaTipo === 'medimentor') {
                return this.state.listRegistros.results.map((item) => {
                    const showVideoButton = item.situacao === 'liberado';

                    return (
                        <tr key={item.id}>
                            <td data-label="ID">{item.id}</td>
                            <td>{formataDataHoraExibicao(item.data_agendamento)}</td>
                            <td>{item.dados_prestador.nome}</td>
                            <td>{item.dados_mentorado.nome}</td>
                            <td>{item.dados_servico_procedimento.nome}</td>
                            <td>{formataDataHoraExibicao(item.data_solicitacao)}</td>
                            {hasPerm('view_faturamentos') && (
                                <td>{formatarValorLocal(item.valor)}</td>
                            )}
                            <td><div className="td-border"><span className={`badge-agendamento badge-sm badge-status-${item.situacao}`}>{situacoesAgendamento[item.situacao]}</span></div></td>
                            <td>
                                {this.state.dados_usuario['tipo_usuario'] !== 'prestador' && this.state.dados_usuario['tipo_usuario'] !== 'beneficiario' && (
                                    <Button variant="light" href={"/agendamentos/edit/"+item.id} size="sm">
                                        <FaRegEdit /> Editar
                                    </Button>
                                )}
                                {(this.state.dados_usuario['tipo_usuario'] === 'prestador' || this.state.dados_usuario['tipo_usuario'] === 'beneficiario') && item.dados_meeting?.whereby_sala_id && item.dados_meeting?.whereby_sala_url && showVideoButton && (
                                    <Button variant="secondary" className="btn-sm" href={"/meetings/view/"+item.id} size="sm">
                                        Vídeo Conferência
                                    </Button>
                                )}
                                {/* quem confirma a realização é quem conduziu a sessão: o mentorado
                                    também é prestador e enxerga a mesma listagem */}
                                {item.situacao != 'finalizado' && item.situacao != 'cancelado' && this.state.dados_usuario['tipo_usuario'] === 'prestador' && item.prestador_id === this.state.dados_usuario['prestador_id'] && (
                                    <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarServico(item)}>
                                        Confirmar Realização
                                    </Button>
                                )}
                            </td>
                        </tr>
                    );
                });
            }

            return this.state.listRegistros.results.map((item) => {
                const dataAgendamento = moment(item.data_agendamento).tz("America/Sao_Paulo");
                const tolerancia = dataAgendamento.add(10, 'hours');
                const showVideoButton = true;// now.isBefore(tolerancia) && item.situacao === 'liberado';

                return (
                    <tr key={item.id}>
                        <td data-label="ID">{item.id}</td>
                        <td>{formataDataHoraExibicao(item.data_agendamento)}</td>
                        {this.state.dados_usuario['tipo_usuario'] !== 'prestador' && (
                            <td>{item.dados_prestador.nome}</td>
                        )}
                        <td>{item.dados_beneficiario.nome}{item.dados_mentorado.nome}</td>
                        <td>{item.dados_servico_procedimento.nome}</td>
                        <td>{formataDataHoraExibicao(item.data_solicitacao)}</td>
                        <td><div className="td-border"><span className={`badge-agendamento badge-status-${item.situacao}`}>{situacoesAgendamento[item.situacao]}</span></div></td>
                        <td>
                            {item.atendimento_kit_id ? (
                                <>
                                    {item.dados_atendimento_kit?.status === 'cancelado' ? (
                                        <span>Cancelado</span>
                                    ) : (
                                        <>
                                            <span>Sim</span>
                                            {item.dados_atendimento_kit.data_envio && (
                                                <p className="mb-1 p-info">Previsão: {formataDataExibicao(item.dados_atendimento_kit.data_envio)}</p>
                                            )}
                                            {item.dados_atendimento_kit.data_envio_realizado && (
                                                <p className="mb-1 p-info">Enviado em: {formataDataExibicao(item.dados_atendimento_kit.data_envio_realizado)}</p>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <span>Não</span>
                            )}
                        </td> 
                        <td>
                            {this.state.dados_usuario['tipo_usuario'] !== 'prestador' && this.state.dados_usuario['tipo_usuario'] !== 'beneficiario' && (
                                <Button variant="light" href={"/agendamentos/edit/"+item.id} size="sm">
                                    <FaRegEdit /> Editar
                                </Button>    
                            )}
                            {(this.state.dados_usuario['tipo_usuario'] === 'prestador' || this.state.dados_usuario['tipo_usuario'] === 'beneficiario') && item.dados_meeting?.whereby_sala_id && item.dados_meeting?.whereby_sala_url && showVideoButton && (
                                <Button variant="secondary" className="btn-sm" href={"/meetings/view/"+item.id} size="sm">
                                    Vídeo Conferência
                                </Button>    
                            )}
                            {item.situacao != 'finalizado' && item.situacao != 'cancelado' && item.situacao != 'arquivo_pendente' && this.state.dados_usuario['tipo_usuario'] === 'prestador' && (
                                <>
                                    <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarServico(item)}>
                                        Confirmar Realização
                                    </Button>
                                    {this.deveMostrarBotaoFormularioDinamico(item) && (
                                        <Button variant="info" size="sm" className="me-2 mb-1 mt-1 text-white" onClick={() => this.handleEnviaCadastroFormularioDinamico(item)}>
                                            <i className="fa fa-list-alt me-1"></i>
                                            {this.getTituloBotaoFormularioDinamico(item)}
                                        </Button>
                                    )}
                                </> 
                            )}
                            {item.situacao === 'arquivo_pendente' && (
                                <>
                                    {(() => {
                                        const configValidacao = getConfig(item.dados_programa?.configuracoes || item?.dados_atendimento?.programa?.configuracoes, 'agendamento.validacao_arquivos', false);
                                        const user = getCurrentUser();
                                        const podeAnalisar = ['operador', 'gestor', ''].includes(user.tipo_usuario) || (user.tipo_usuario === 'prestador' && configValidacao && user.prestador_categoria !== 'medicos');

                                        return podeAnalisar && (
                                            <Button variant="warning" size="sm" className="me-2 mb-1 mt-1 text-dark" onClick={() => this.handleShowModalArquivos(item)}>
                                                <FaFile /> Arquivos
                                            </Button>
                                        );
                                    })()}
                                </>
                            )}
                            {item.atendimento_kit_id && item.dados_atendimento_kit?.status === 'agendado' && (
                                <Button variant="success" size="sm" className="me-2 mb-1 mt-1" onClick={() => this.handleConfirmarEnvioKit(item.atendimento_kit_id, item)}>
                                    Confirmar Envio Kit
                                </Button>
                            )}
                            {item.atendimento_uuid && (
                                <Button variant="light" href={"/atendimentos/edit/"+item.atendimento_uuid} size="sm">
                                    <FaEye /> Ver Atendimento
                                </Button>    
                            )}
                        </td>
                    </tr>
                );
            });
        }

        return (
            <tr>
                <td colSpan={6}>Nenhum agendamento cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        const value = e.target.value;
        this.setState({ busca: value });
        this.debouncedConsulta(value);
    }

    renderTabelaAnterior = () => {
        const dados_user = this.state.dados_usuario || {};
        const cachedPogramaTipo = localStorage.getItem(`programa_tipo_${dados_user['ambiente_programa_id']}`);
        return (
            //mesma razao da /atendimentos: o card fecha antes da listagem nova
            <Card className="cardDestaque">
                <Card.Body>
            <Table responsive className="custom-table">
                <thead>
                    {cachedPogramaTipo === 'medimentor' ? (
                    <tr>
                        <th>ID</th>
                        <th>Data do Agendamento</th>
                        <th>Mentor</th>
                        <th>Mentorado</th>
                        <th>Serviço/Procedimento</th>
                        <th>Data de Solicitação</th>
                        {hasPerm('view_faturamentos') && (<th>Valor</th>)}
                        <th>Situação</th>
                        <th></th>
                    </tr>
                    ) : (
                    <tr>
                        <th>ID</th>
                        <th>Data do Agendamento</th>
                        {dados_user['tipo_usuario'] != 'prestador' && (<th>Prestador</th>)}
                        <th>Paciente</th>
                        <th>Serviço/Procedimento</th>
                        <th>Data de Solicitação</th>
                        <th>Situação</th>
                        <th>Envio Kit</th>
                        <th></th>
                    </tr>
                    )}
                </thead>
                <tbody>
                    {this.state.loading ? (
                        <tr><td colSpan={9}>Carregando...</td></tr>
                    ) : this.state.error ? (
                        <tr><td colSpan={9}>{this.state.error}</td></tr>
                    ) : this.renderRows()}
                </tbody>
            </Table>
                </Card.Body>
            </Card>
        );
    }

    render() {
        if (!hasPerm('view_agendamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        const dados_user = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Agendamentos</h4>
                    </Col>
                    {this.state.dados_usuario['tipo_usuario'] != 'prestador' && this.state.dados_usuario['tipo_usuario'] != 'beneficiario' && !isEdicaoAgendamentoBloqueada(this.state.configProgramaAtual) && (
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/agendamentos/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Agendamento
                        </Button>
                    </Col>
                    )}
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row className="mb-3 align-items-center">
                            <Col sm={12} md={4} lg={3}>
                                {/* Lista e cards: a mesma informação em duas densidades.
                                    A escolha fica salva por usuário. No layout anterior o
                                    alternador não tem o que alternar, então nem aparece. */}
                                {usaLayoutNovoListas(this.state.configProgramaAtual) && (
                                <div className="btn-group btn-group-sm" role="group" aria-label="Modo de visualização">
                                    <Button
                                        variant={this.state.visao === 'lista' ? 'secondary' : 'outline-secondary'}
                                        onClick={() => this.trocarVisao('lista')}
                                    >
                                        <FaList className="me-1" /> Lista
                                    </Button>
                                    <Button
                                        variant={this.state.visao === 'cards' ? 'secondary' : 'outline-secondary'}
                                        onClick={() => this.trocarVisao('cards')}
                                    >
                                        <FaThLarge className="me-1" /> Cards
                                    </Button>
                                </div>
                                )}
                            </Col>
                            <Col sm={12} md={4} lg={4}>
                                <Form.Group className="d-flex align-items-center" style={{ gap: '8px' }}>
                                    <Form.Label className="mb-0 text-nowrap" style={{ fontSize: '13px', color: '#6b7a8d' }}>
                                        Ordenar por
                                    </Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={this.state.ordenacao}
                                        onChange={(e) => this.trocarOrdenacao(e.target.value)}
                                    >
                                        {ORDENACOES.map((o) => (
                                            <option key={o.valor} value={o.valor}>{o.rotulo}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col sm={12} md={4} lg={5}>
                                <Form.Group className="d-flex align-items-center" style={{ gap: '8px' }}>
                                    <InputGroup>
                                        <InputGroup.Text className="bg-light border-end-0">
                                            <FaSearch className="text-muted" />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            placeholder="Buscar por Paciente..."
                                            value={this.state.busca}
                                            onChange={this.onChangeBusca}
                                            className="border-start-0 ps-0"
                                        />
                                    </InputGroup>
                                    {this.podeUsarFiltrosOperacao() && (
                                        <Button
                                            variant={this.state.filtros_abertos ? 'secondary' : 'light'}
                                            size="sm"
                                            className="text-nowrap"
                                            onClick={() => this.setState({ filtros_abertos: !this.state.filtros_abertos })}
                                            aria-expanded={this.state.filtros_abertos}
                                        >
                                            <FaFilter /> Filtros
                                            {this.contarFiltrosAtivos() > 0 && (
                                                <Badge bg="primary" className="ms-1">{this.contarFiltrosAtivos()}</Badge>
                                            )}
                                        </Button>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Painel de filtros da operação: abre e FICA aberto até clicar de novo,
                            então dá para ajustar e ver o resultado abaixo sem reabrir. Cada
                            campo já reconsulta ao mudar. */}
                        {this.podeUsarFiltrosOperacao() && this.state.filtros_abertos && (
                        <Row className="mb-1">
                            <Col sm={12}>
                                <div className="painel-filtros-simples">
                                    <Row>
                                        <Col sm={12} md={6} lg={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data início</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    size="sm"
                                                    value={this.state.filtro_data_inicio}
                                                    onChange={(e) => this.aplicarFiltro({ filtro_data_inicio: e.target.value })}
                                                    disabled={this.state.filtro_sem_data}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} md={6} lg={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data fim</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    size="sm"
                                                    value={this.state.filtro_data_fim}
                                                    onChange={(e) => this.aplicarFiltro({ filtro_data_fim: e.target.value })}
                                                    disabled={this.state.filtro_sem_data}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} md={6} lg={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Prestador</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    isClearable
                                                    placeholder="Buscar prestador..."
                                                    loadingMessage={() => 'Buscando...'}
                                                    noOptionsMessage={() => 'Digite ao menos 2 letras'}
                                                    loadOptions={this.carregarPrestadores}
                                                    value={this.state.filtro_prestador_id
                                                        ? { value: this.state.filtro_prestador_id, label: this.state.filtro_prestador_nome }
                                                        : null}
                                                    onChange={(opcao) => this.aplicarFiltro({
                                                        filtro_prestador_id: opcao ? opcao.value : '',
                                                        filtro_prestador_nome: opcao ? opcao.label : '',
                                                    })}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} md={6} lg={3}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status do agendamento</Form.Label>
                                                <Form.Select
                                                    size="sm"
                                                    value={this.state.filtro_situacao}
                                                    onChange={(e) => this.aplicarFiltro({ filtro_situacao: e.target.value })}
                                                >
                                                    <option value="">Todos</option>
                                                    {Object.entries(situacoesAgendamento).map(([valor, rotulo]) => (
                                                        <option key={valor} value={valor}>{rotulo}</option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} md={6} lg={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="d-none d-lg-block">&nbsp;</Form.Label>
                                                {/* a fila de quem ainda precisa combinar horário com o
                                                    paciente; com ela as datas não fazem sentido */}
                                                <Form.Check
                                                    type="checkbox"
                                                    id="filtro_sem_data"
                                                    label="Somente sem data"
                                                    checked={this.state.filtro_sem_data}
                                                    onChange={(e) => this.aplicarFiltro({
                                                        filtro_sem_data: e.target.checked,
                                                        filtro_data_inicio: e.target.checked ? '' : this.state.filtro_data_inicio,
                                                        filtro_data_fim: e.target.checked ? '' : this.state.filtro_data_fim,
                                                    })}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Button type="button" variant="light" size="sm" onClick={this.limparFiltros}>
                                        <FaEraser /> Limpar filtros
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        )}

                    </Card.Body>
                </Card>

                {/* As duas visões ficam FORA do .cardDestaque de propósito: são superfícies
                    brancas e precisam do cinza da aplicação atrás para se destacar. Dentro
                    do container branco era branco sobre branco. */}
                <>
                        {this.state.loading ? (
                            <div style={{ padding: '4px', fontSize: '13px', color: '#6b7a8d' }}>Carregando...</div>
                        ) : this.state.error ? (
                            <div style={{ padding: '4px', fontSize: '13px', color: '#9b3b45' }}>{this.state.error}</div>
                        ) : (
                            !usaLayoutNovoListas(this.state.configProgramaAtual) ? (
                                this.renderTabelaAnterior()
                            ) : (
                            (() => {
                                //mesmas props nas duas visões: elas não podem divergir em regra
                                const Visao = this.state.visao === 'cards' ? CardsAgendamentos : LinhasDensasAgendamentos;
                                return (
                                    <Visao
                                        itens={this.state.listRegistros?.results || []}
                                        dadosUsuario={this.state.dados_usuario || {}}
                                        podeEditar={this.podeEditarAgendamento}
                                        podeInformarData={this.podeInformarData}
                                        ehAlteracaoDeData={this.ehAlteracaoDeData}
                                        mostrarFormularioDinamico={this.deveMostrarBotaoFormularioDinamico}
                                        tituloFormularioDinamico={this.getTituloBotaoFormularioDinamico}
                                        podeAnalisarArquivos={this.podeAnalisarArquivos}
                                        onConfirmarRealizacao={this.handleConfirmarServico}
                                        onInformarData={this.abrirModalData}
                                        onFormularioDinamico={this.handleEnviaCadastroFormularioDinamico}
                                        onArquivos={this.handleShowModalArquivos}
                                        onConfirmarEnvioKit={this.handleConfirmarEnvioKit}
                                    />
                                );
                            })()
                        ))}
                        {'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && (
                            <div className="mt-3">
                                <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                            </div>
                        )}
                </>

                {/* Data combinada pelo prestador com o paciente, em agendamento que nasceu sem data */}
                <Modal enforceFocus={false} show={this.state.showModalInformarData} onHide={() => this.setState({ showModalInformarData: false, agendamentoInformarData: null })} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Informar Data do Agendamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.agendamentoInformarData && (
                            <>
                                <p className="mb-3">
                                    <strong>{this.state.agendamentoInformarData.dados_servico_procedimento?.nome}</strong>
                                    {' — '}
                                    {this.state.agendamentoInformarData.dados_beneficiario?.nome}
                                </p>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data do agendamento <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="datetime-local"
                                        value={this.state.informar_data}
                                        onChange={(e) => this.setState({ informar_data: e.target.value })}
                                    />
                                </Form.Group>
                                {this.state.agendamentoInformarData.dados_servico_procedimento?.permite_alterar_valor_agendamento && (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Valor do serviço</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="0,00"
                                            value={this.state.informar_valor}
                                            onChange={(e) => this.setState({ informar_valor: e.target.value })}
                                        />
                                    </Form.Group>
                                )}
                                <p className="text-muted mb-0">
                                    <small>Ao salvar, a navegadora é avisada por e-mail da atualização.</small>
                                </p>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showModalInformarData: false, agendamentoInformarData: null })}>
                            Cancelar
                        </Button>
                        <Button variant="success" disabled={this.state.salvandoData} onClick={this.salvarDataAgendamento}>
                            {this.state.salvandoData ? 'Salvando...' : 'Salvar Data'}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Confirmação de Realização de Serviço */}
                <ConfirmarRealizacaoModal
                    show={this.state.showConfirmarRealizacaoModal}
                    onHide={() => this.setState({ showConfirmarRealizacaoModal: false, agendamentoParaConfirmar: null })}
                    agendamento={{
                        ...this.state.agendamentoParaConfirmar,
                        dados_programa: this.state.agendamentoParaConfirmar?.dados_programa || this.state.agendamentoParaConfirmar?.dados_atendimento?.programa
                    }}
                    contextData={{
                        beneficiario_id: this.state.agendamentoParaConfirmar?.beneficiario_id,
                        atendimento_id: this.state.agendamentoParaConfirmar?.atendimento_id,
                        etapa_atual: this.state.agendamentoParaConfirmar?.etapa_atual,
                        prestador_nome: this.state.agendamentoParaConfirmar?.dados_prestador?.nome
                    }}
                    programa_config={this.state.agendamentoParaConfirmar?.dados_programa?.configuracoes || this.state.agendamentoParaConfirmar?.dados_atendimento?.programa?.configuracoes}
                    onSuccess={() => {
                        this.setState({ showConfirmarRealizacaoModal: false, agendamentoParaConfirmar: null });
                        window.location.reload();
                    }}
                />

                {/* Modal de Formulário Dinâmico de Serviços */}
                <ModalPersonalizadoServicos
                    show={this.state.showModalPersonalizadoServicos}
                    onHide={() => this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false })}
                    agendamento={this.state.agendamentoFormularioDinamico}
                    contextData={{
                        atendimento_id: this.state.agendamentoFormularioDinamico?.atendimento_id,
                        etapa_atual: this.state.agendamentoFormularioDinamico?.etapa_atual,
                    }}
                    onSuccess={() => {
                        this.setState({ showModalPersonalizadoServicos: false, agendamentoFormularioDinamico: null, formularioDinamicoReadOnly: false });
                        window.location.reload();
                    }}
                    readOnly={this.state.formularioDinamicoReadOnly}
                />

                {/* Modal de Arquivos */}
                <Modal size="xl" show={this.state.showModalArquivos} onHide={this.handleCloseModalArquivos}>
                    <Modal.Header closeButton>
                        <Modal.Title>Arquivos do Agendamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={12}>
                                <div className="row-list">
                                    <Form.Label className="mb-0">
                                        DADOS DO AGENDAMENTO
                                    </Form.Label>
                                    <hr className="mb-2 mt-1"></hr>
                                    <p className="mb-1">
                                        <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PACIENTE:</small> <strong>{this.state.agendamento_selecionado?.dados_beneficiario?.nome}</strong>
                                    </p>
                                    {this.state.agendamento_selecionado?.dados_beneficiario?.celular && (
                                        <p>
                                            <small>TELEFONE PACIENTE:</small> <strong>{this.state.agendamento_selecionado.dados_beneficiario.celular}</strong>
                                        </p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        {this.state.loadingArquivos ? (
                            <div className="text-center p-3">
                                <span className="spinner-border spinner-border-sm me-2"></span>Carregando arquivos...
                            </div>
                        ) : this.state.arquivos.length > 0 ? (
                            (() => {
                                const evt = this.state.agendamento_selecionado;
                                const config = evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes;
                                
                                const aprovaAutomatico = getConfig(config, 'aprova_laudo_automatico', true);
                                const showStatusColumn = !aprovaAutomatico;
                                
                                return (
                                <div className="table-responsive">
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            <th>Arquivo</th>
                                            <th className="text-nowrap">Data</th>
                                            <th className="text-nowrap">Tipo</th>
                                            {showStatusColumn && <th className="text-nowrap">Status</th>}
                                            { getCurrentUser().tipo_usuario !== 'prestador' && <th className="text-end text-nowrap" style={{ width: '1%' }}>Opções</th> }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.arquivos.map((arquivo) => {
                                            const dados_user = getCurrentUser();
                                            const usuarioLogadoId = String(dados_user.id);
                                            const arquivoAutorId = String(arquivo.cadastrado_por_id);
                                            const isAutor = usuarioLogadoId === arquivoAutorId;
                                            
                                            const validacaoArquivosHabilitada = getConfig(
                                                config, 
                                                'agendamento.validacao_arquivos', 
                                                false
                                            );

                                            const isNavegadora = ['', 'operador', 'gestor'].includes(dados_user.tipo_usuario);
                                            
                                            const podeAvaliar = (dados_user.tipo_usuario === '' || !isAutor) && arquivo.aprovado === null && isNavegadora;

                                            const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(config);

                                            return (
                                                <tr key={arquivo.id}>
                                                    <td>
                                                        {isBloqueadoVisualizarLaudo ? (
                                                            <span className="text-muted" title="Visualização bloqueada">
                                                                {arquivo.nome} <FaExclamationTriangle className="text-warning" />
                                                            </span>
                                                        ) : (
                                                            <a href={arquivo.arquivo} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                                                {arquivo.nome} <FaDownload size={12} />
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td className="text-nowrap">{formataDataHoraExibicao(arquivo.data)}</td>
                                                    <td className="text-nowrap">{tiposArquivos[arquivo.tipo] || arquivo.tipo}</td>
                                                    {showStatusColumn && (
                                                        <td className="text-nowrap">
                                                            {arquivo.aprovado === true && <Badge bg="success">Aprovado</Badge>}
                                                            {(arquivo.aprovado === null || arquivo.aprovado === undefined) && <Badge bg="warning" text="dark">Pendente</Badge>}
                                                            {arquivo.aprovado === false && (
                                                                <OverlayTrigger placement="top" overlay={<Tooltip>{arquivo.motivo_recusa}</Tooltip>}>
                                                                    <Badge bg="danger" style={{ cursor: 'help' }}>Recusado <FaExclamationTriangle /></Badge>
                                                                </OverlayTrigger>
                                                            )}
                                                        </td>
                                                    )}
                                                    { getCurrentUser().tipo_usuario !== 'prestador' && (
                                                    <td className="text-end text-nowrap">
                                                        {/* Botões de Aprovar/Recusar - Superuser vê se tiver validacao habilitada (mesmo que seja autor, para teste) */}
                                                        {podeAvaliar && (
                                                            <>
                                                                <Button 
                                                                    variant="outline-success" 
                                                                    size="sm" 
                                                                    className="me-1" 
                                                                    onClick={() => this.handleAprovarArquivo(arquivo.id)}
                                                                    title="Aprovar"
                                                                >
                                                                    <FaCheck />
                                                                </Button>
                                                                <Button 
                                                                    variant="outline-danger" 
                                                                    size="sm" 
                                                                    className="me-1"
                                                                    onClick={() => this.handleRecusarArquivo(arquivo.id)}
                                                                    title="Recusar"
                                                                >
                                                                    <FaTimes />
                                                                </Button>
                                                            </>
                                                        )}

                                                        {/* Botões de Edição/Exclusão - Superuser vê SEMPRE junto com aprovação se quiser */}
                                                        {(dados_user['tipo_usuario'] == '' || dados_user['tipo_usuario'] === 'operador') && (
                                                            <>
                                                                <Button variant="outline-primary" size="sm" className="me-1" onClick={() => this.editarArquivo(arquivo)} title="Editar">
                                                                    <FaEdit />
                                                                </Button>
                                                                <Button variant="outline-danger" size="sm" onClick={() => this.excluirArquivo(arquivo.id)} title="Excluir">
                                                                    <FaTrash />
                                                                </Button>
                                                            </>
                                                        )}
                                                    </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                            );
                            })()
                        ) : (
                            <p className="text-center text-muted">Nenhum arquivo encontrado.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={this.handleCloseModalArquivos}>
                            Fechar
                        </Button>
                        {(() => {
                            const evt = this.state.agendamento_selecionado;
                            const configValidacao = getConfig(evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes, 'agendamento.validacao_arquivos', false);
                            
                            const user = getCurrentUser();
                            const podeAdicionar = (['operador', 'gestor', ''].includes(user.tipo_usuario) || (user.tipo_usuario === 'prestador' && configValidacao));
                            
                            const isBloqueadoVisualizarLaudo = isLaudoBloqueadoParaUsuarioAtual(
                                evt?.dados_programa?.configuracoes || evt?.dados_atendimento?.programa?.configuracoes
                            );

                            return podeAdicionar && !isBloqueadoVisualizarLaudo && evt?.situacao !== "cancelado" && (
                                <Button variant="secondary" onClick={() => this.handleShowModalArquivosEdit()}>
                                    <FaPlus /> Cadastrar Novo Arquivo
                                </Button>
                            );
                        })()}
                    </Modal.Footer>
                </Modal>

                {/* Modal de Upload de Arquivo */}
                <Modal size="xl" show={this.state.showModalArquivosEdit} onHide={this.handleCloseModalArquivosEdit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Novo Arquivo - Agendamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         <Row>
                            <Col sm={12}>
                                <div className="row-list mb-3">
                                    <Form.Label className="mb-0">
                                        DADOS DO AGENDAMENTO
                                    </Form.Label>
                                    <hr className="mb-2 mt-1"></hr>
                                    <p className="mb-1">
                                        <small>SERVIÇO:</small> <strong>{this.state.agendamento_selecionado?.dados_servico_procedimento?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PRESTADOR:</small> <strong>{this.state.agendamento_selecionado?.dados_prestador?.nome}</strong>
                                    </p>
                                    <p className="mb-1">
                                        <small>PACIENTE:</small> <strong>{this.state.agendamento_selecionado?.dados_beneficiario?.nome}</strong>
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        <Form onSubmit={this.saveArquivo}>
                            <Row>
                                <Col sm={12} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Anexe abaixo um novo arquivo</Form.Label>
                                        <Form.Control type="file" onChange={this.onChangeArquivo} />
                                        <Form.Text className="text-danger">{this.state.arquivoHelper}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control type="text" value={this.state.arquivo_nome} placeholder="Ex: Laudo X" onChange={e => this.handleChange(e, 'arquivo_nome')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={6} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo</Form.Label>
                                        <Form.Control as="select" value={this.state.arquivo_tipo} onChange={e => this.handleChange(e, 'arquivo_tipo')}>
                                            <option value="">Selecione...</option>
                                            {Object.entries(tiposArquivos).map(([sigla, nome]) => (
                                                <option key={sigla} value={sigla}>{nome}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button type="submit" variant="secondary" disabled={this.state.loadingArquivos}>
                                    {this.state.loadingArquivos ? <span className="spinner-border spinner-border-sm me-2"></span> : <FaCheck className="me-1" />} 
                                    Enviar Arquivo
                                </Button>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default withRouter(Agendamentos);
